<template>
  <PopoverMenuItem @click="showSwitchToClassicModal" v-close-popover>
    <template #icon>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M2.87354 7.76782C2.87354 7.42264 3.15336 7.14282 3.49854 7.14282H15.4832C15.8284 7.14282 16.1082 7.42264 16.1082 7.76782C16.1082 8.113 15.8284 8.39282 15.4832 8.39282H3.49854C3.15336 8.39282 2.87354 8.113 2.87354 7.76782Z"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M4.17776 3.30762H14.8087C15.2583 3.31091 15.6886 3.49099 16.0065 3.80891C16.3244 4.12682 16.5045 4.55707 16.5078 5.00666L16.5078 5.01124L16.5078 8.65457C16.5078 8.99975 16.228 9.27957 15.8828 9.27957C15.5376 9.27957 15.2578 8.99975 15.2578 8.65457V5.01402C15.2564 4.89342 15.2079 4.77811 15.1226 4.69279C15.0373 4.60748 14.922 4.55897 14.8014 4.55762H4.18053C4.05993 4.55897 3.94462 4.60748 3.85931 4.69279C3.774 4.7781 3.72549 4.89341 3.72414 5.01401V14.0369C3.72549 14.1575 3.774 14.2728 3.85931 14.3581C3.94463 14.4434 4.05994 14.4919 4.18054 14.4933H9.90642C10.2516 14.4933 10.5314 14.7731 10.5314 15.1183C10.5314 15.4635 10.2516 15.7433 9.90642 15.7433H4.17318C3.72359 15.74 3.29335 15.5599 2.97543 15.242C2.65751 14.9241 2.47745 14.4938 2.47415 14.0443L2.47412 14.0397L2.47414 5.00666C2.47743 4.55707 2.65751 4.12682 2.97543 3.80891C3.29335 3.49099 3.72359 3.31093 4.17318 3.30763L4.17776 3.30762Z"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M17.1381 12.1787C16.7084 11.9064 16.2099 11.7626 15.7012 11.7644L15.698 11.7644C15.2217 11.7637 14.7535 11.888 14.3402 12.1248C13.9269 12.3617 13.5829 12.7028 13.3427 13.1141C13.1025 13.5255 12.9744 13.9927 12.9713 14.469C12.9681 14.9454 13.0899 15.4142 13.3247 15.8287C13.5594 16.2432 13.8987 16.5889 14.3088 16.8312C14.719 17.0736 15.1855 17.204 15.6618 17.2097C16.1381 17.2153 16.6076 17.0958 17.0233 16.8633C17.439 16.6307 17.7864 16.2931 18.0308 15.8842C18.208 15.588 18.5917 15.4914 18.888 15.6685C19.1843 15.8456 19.2809 16.2294 19.1037 16.5256C18.7471 17.1222 18.2402 17.6148 17.6336 17.9541C17.027 18.2935 16.342 18.4678 15.647 18.4596C14.952 18.4514 14.2714 18.261 13.673 17.9074C13.0746 17.5538 12.5794 17.0494 12.2369 16.4446C11.8945 15.8398 11.7167 15.1557 11.7213 14.4607C11.7259 13.7657 11.9128 13.084 12.2633 12.4838C12.6138 11.8836 13.1156 11.3859 13.7187 11.0403C14.3212 10.695 15.0038 10.5136 15.6983 10.5144C16.4449 10.5121 17.1766 10.7232 17.8073 11.1229C18.0988 11.3076 18.1854 11.6938 18.0006 11.9853C17.8158 12.2769 17.4297 12.3635 17.1381 12.1787Z"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M18.1125 10.3757C18.4549 10.332 18.7679 10.5741 18.8117 10.9165L18.9954 12.3546C19.0165 12.5196 18.971 12.6862 18.8688 12.8175C18.7667 12.9489 18.6164 13.034 18.4513 13.0542L17.0131 13.23C16.6705 13.2719 16.3588 13.0281 16.3169 12.6854C16.2751 12.3428 16.5189 12.0311 16.8615 11.9892L17.6759 11.8897L17.5718 11.0749C17.528 10.7325 17.7701 10.4195 18.1125 10.3757Z"
        />
      </svg>
    </template>
    <template #title>
      {{ $t('Switch to Classic Teamwork') }}
    </template>
  </PopoverMenuItem>
</template>

<script>
import { useVersionSwitcher } from '@/platform/composables/useVersionSwitcher';

export default {
  components: {
    PopoverMenuItem: () => import('./PopoverMenuActionItem.vue'),
  },

  setup() {
    const { showSwitchToClassicModal } = useVersionSwitcher();

    return {
      showSwitchToClassicModal,
    };
  },
};
</script>
